import { useEffect, useState } from "react";
import {
  slugify,
} from "../../data/cmsStore";
import { cmsAdminApi } from "../../api/cmsApi";

const emptyForm = {
  id: "",
  title: "",
  slug: "",
  categoryId: "",
  excerpt: "",
  content: "",
  image: "/img/blog/blog-aws.svg",
  author: "Emicron Team",
  readTime: "5 min read",
  tags: "",
  publishedAt: new Date().toISOString().slice(0, 10),
  status: "published",
};

export default function AdminBlogsPage() {
  const [blogs, setBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState("");

  const refresh = async () => {
    try {
      const [blogsData, catData] = await Promise.all([
        cmsAdminApi.listBlogs(),
        cmsAdminApi.listBlogCategories(),
      ]);
      setBlogs(blogsData);
      setCategories(catData);
      setError("");
    } catch (e) {
      setError(e.message || "Could not load blogs");
    }
  };
  useEffect(() => {
    refresh();
  }, []);
  const catName = (id) => categories.find((c) => c.id === id)?.name || "—";

  const openCreate = () => {
    setForm({ ...emptyForm, categoryId: categories[0]?.id || "" });
    setEditing(true);
  };

  const openEdit = (blog) => {
    setForm({ ...blog });
    setEditing(true);
  };

  const onSave = async (e) => {
    e.preventDefault();
    await cmsAdminApi.saveBlog(form);
    setEditing(false);
    setForm(emptyForm);
    await refresh();
  };

  const onDelete = async (id) => {
    if (!window.confirm("Delete this blog?")) return;
    await cmsAdminApi.deleteBlog(id);
    await refresh();
  };

  return (
    <div className="admin-page">
      <header className="admin-page-head">
        <div>
          <h1>Blogs</h1>
          <p>Add, edit, or remove blog posts.</p>
        </div>
        <button type="button" className="admin-btn admin-btn-primary" onClick={openCreate}>
          <i className="bi bi-plus-lg" /> Add blog
        </button>
      </header>
      {error ? <p className="text-danger">{error}</p> : null}

      {editing ? (
        <form className="admin-panel admin-form" onSubmit={onSave}>
          <div className="admin-panel-head">
            <h2>{form.id ? "Edit blog" : "New blog"}</h2>
            <button type="button" className="admin-btn admin-btn-ghost" onClick={() => setEditing(false)}>Cancel</button>
          </div>
          <div className="admin-form-grid">
            <label>Title
              <input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value, slug: form.id ? form.slug : slugify(e.target.value) })} />
            </label>
            <label>Slug
              <input required value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} />
            </label>
            <label>Category
              <select required value={form.categoryId} onChange={(e) => setForm({ ...form, categoryId: e.target.value })}>
                <option value="">Select</option>
                {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </label>
            <label>Author
              <input value={form.author} onChange={(e) => setForm({ ...form, author: e.target.value })} />
            </label>
            <label>Read time
              <input value={form.readTime || ""} onChange={(e) => setForm({ ...form, readTime: e.target.value })} placeholder="6 min read" />
            </label>
            <label>Published date
              <input type="date" value={form.publishedAt} onChange={(e) => setForm({ ...form, publishedAt: e.target.value })} />
            </label>
            <label>Status
              <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
                <option value="published">Published</option>
                <option value="draft">Draft</option>
              </select>
            </label>
            <label className="admin-form-span">Image URL
              <input value={form.image} onChange={(e) => setForm({ ...form, image: e.target.value })} />
            </label>
            <label className="admin-form-span">Tags (comma separated)
              <input value={form.tags || ""} onChange={(e) => setForm({ ...form, tags: e.target.value })} />
            </label>
            <label className="admin-form-span">Excerpt
              <textarea rows={2} value={form.excerpt} onChange={(e) => setForm({ ...form, excerpt: e.target.value })} />
            </label>
            <label className="admin-form-span">Content (use ## for headings, - for bullets)
              <textarea rows={8} required value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} />
            </label>
          </div>
          <div className="admin-form-actions">
            <button type="submit" className="admin-btn admin-btn-primary">Save blog</button>
          </div>
        </form>
      ) : null}

      <div className="admin-panel">
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Category</th>
                <th>Status</th>
                <th>Date</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {blogs.map((b) => (
                <tr key={b.id}>
                  <td>
                    <div className="admin-blog-cell">
                      <img src={`${process.env.PUBLIC_URL || ""}${b.image}`} alt="" />
                      <strong>{b.title}</strong>
                    </div>
                  </td>
                  <td>{catName(b.categoryId)}</td>
                  <td><span className={`admin-pill admin-pill--${b.status}`}>{b.status}</span></td>
                  <td>{b.publishedAt}</td>
                  <td className="admin-actions">
                    <button type="button" className="admin-btn admin-btn-sm" onClick={() => openEdit(b)}>Edit</button>
                    <button type="button" className="admin-btn admin-btn-sm admin-btn-danger" onClick={() => onDelete(b.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
